import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/app/catalog-client.tsx");
